import { initVideoGallery } from "../components/gn_video-gallery";

window.Drupal.behaviors.app_video_gallery = {
  attach: (context, settings) => {
    initVideoGallery(context);
  },
};
